import HotelService from '@/service/HotelService';
import PackageService from '@/service/PackageService';
import { defineStore } from 'pinia';
import { useIndexStore } from './IndexStore';

export const useHotelStore = defineStore('hotelStore', {
  state: () => ({
    hotelMultiple: [],
    hotelMultipleOnlyHotel: [],
    hotelByCodePackage: {},
    hotelRoomCategory: new Map(),
    isLoading: false
  }),
  getters: {
    selectHotelMultiple: (state) => state.hotelMultiple,
    selectHotelMultipleOnlyHotel: (state) => state.hotelMultipleOnlyHotel,
    selectHotelByCodePackage: (state) => state.hotelByCodePackage,
    selectHotelRoomCategory: (state) => state.hotelRoomCategory,
    selectLoading: (state) => state.isLoading
  },
  actions: {
    getHotelByCodePackage(code) {
      this.hotelMultiple.forEach((hotel) => {
        hotel.forEach((h) => {
          if (h.hCode === code) {
            this.hotelByCodePackage = h;
          }
        });
      });
    },
    updateHotelMultiple({ hotels, index }) {
      this.hotelMultiple[index] = hotels;
    },
    updateHotelMultipleOnlyHotel({ hotelDurations, index }) {
      this.hotelMultipleOnlyHotel[index] = hotelDurations;
    },
    updateHotelRoomCategory(key, payload) {
      this.hotelRoomCategory.set(key, payload);
    },
    clearHotelRoomCategory() {
      this.hotelRoomCategory = new Map();
    },
    updateRoomLoading(payload: boolean) {
      this.isLoading = payload;
    },
    clearRoomCategory() {
      this.hotelRoomCategory.clear();
    },
    async getHotelMultiple({ hotelDurations, index, data }) {
      const hotelService = new HotelService();
      const payloadData = {
        ids: hotelDurations,
        quoteType: data?.quoteType,
        departDate: data?.departDate,
        duration: data?.duration
      };
      try {
        const res = await hotelService.getHotels(payloadData);
        const payload = {
          hotels: res.data,
          index: index
        };
        this.updateHotelMultiple(payload);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async getHotelMultipleOnlyHotel({ hotelDurations, index, data }) {
      const payloadData = {
        ids: hotelDurations,
        quoteType: data?.quoteType,
        departDate: data?.departDate,
        duration: data?.duration
      };
      const hotelService = new HotelService();
      try {
        const res = await hotelService.getHotels(payloadData);
        const payload = {
          hotelDurations: res.data,
          index: index
        };
        this.updateHotelMultipleOnlyHotel(payload);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },

    async getHotelRoomCategory(payload, excludeHotelRoom?: any) {
      const hotelService = new HotelService();
      const res = await hotelService.getHotelRoomCategory(payload).finally(() => (this.isLoading = false));
      if (res && !res.data.error) {
        if (excludeHotelRoom) {
          const listRoom = res.data?.filter((room) => !excludeHotelRoom.map((excludeRoom) => excludeRoom.toLowerCase()).includes(room.room.toLowerCase()));
          this.updateHotelRoomCategory(payload.productCode, listRoom);
        } else {
          this.updateHotelRoomCategory(payload.productCode, res.data);
        }
      }
      return res;
    },

    async getRoomCategoryByPackagePlus(payload, excludeHotelRoom?: any, payloadPackage?: any, isAdmin?: boolean) {
      const newPayload = {
        ...payload,
        ...payloadPackage
      };
      const packageService = new PackageService();
      const res = await packageService.getRoomCategoryByPackagePlus(newPayload).finally(() => (this.isLoading = false));
      if (res?.data?.error && isAdmin) {
        return res;
      }
      if (res) {
        res.data?.forEach((room) => {
          room.isPackagePlus = true;
        });
        if (excludeHotelRoom && !res.data[0]?.date) {
          const listRoom = res.data?.filter((room) => !excludeHotelRoom.map((excludeRoom) => excludeRoom.toLowerCase()).includes(room.room.toLowerCase()));
          this.updateHotelRoomCategory(payload.productCode, listRoom);
        } else {
          this.updateHotelRoomCategory(payload.productCode, res.data);
        }
        return res;
      }
    },

    async getHotelRoomCategoryPreReg(payload: any) {
      const hotelService = new HotelService();
      const res = await hotelService.getHotelRoomCategoryPreReg(payload).finally(() => (this.isLoading = false));
      if (res && !res.data.error) {
        this.updateHotelRoomCategory(payload.productCode, res.data);
      }
      return res;
    },

    async getListHotelFormDestination(destinationCode: string) {
      const hotelService = new HotelService();
      const response = await hotelService.getListHotelFormDestination(destinationCode);
      if (response) {
        return response;
      } else {
        return {
          data: []
        };
      }
    }
  }
});
